export default __webpack_public_path__ + "static/media/Label_Trial_2.75143414.svg";